namespace Matrix.Workflow {
    export interface WorkflowInstanceDocumentRow {
        WorkflowInstanceDocumentId?: number;
        WorkflowInstanceId?: number;
        DocumentId?: string;
        DocumentDescription?: string;
        DocumentGroup?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        WorkflowInstanceWorkflowCode?: string;
        WorkflowInstanceStatusCode?: string;
        WorkflowInstanceRowId?: number;
        DocumentName?: string;
        DocumentType?: string;
        DocumentContent?: number[];
        DocumentVersion?: number;
        DocumentRowId?: number;
    }

    export namespace WorkflowInstanceDocumentRow {
        export const idProperty = 'WorkflowInstanceDocumentId';
        export const nameProperty = 'DocumentId';
        export const localTextPrefix = 'Workflow.WorkflowInstanceDocument';
        export const deletePermission = 'DataAdmin:WorkflowInstance';
        export const insertPermission = 'DataAdmin:WorkflowInstance';
        export const readPermission = 'Read:WorkflowInstance';
        export const updatePermission = 'DataAdmin:WorkflowInstance';

        export declare const enum Fields {
            WorkflowInstanceDocumentId = "WorkflowInstanceDocumentId",
            WorkflowInstanceId = "WorkflowInstanceId",
            DocumentId = "DocumentId",
            DocumentDescription = "DocumentDescription",
            DocumentGroup = "DocumentGroup",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            WorkflowInstanceWorkflowCode = "WorkflowInstanceWorkflowCode",
            WorkflowInstanceStatusCode = "WorkflowInstanceStatusCode",
            WorkflowInstanceRowId = "WorkflowInstanceRowId",
            DocumentName = "DocumentName",
            DocumentType = "DocumentType",
            DocumentContent = "DocumentContent",
            DocumentVersion = "DocumentVersion",
            DocumentRowId = "DocumentRowId"
        }
    }
}
